module.exports = __webpack_public_path__ + "img/group-3@3x.a84b8e1e.png";